import Quill from 'quill';
const Block = Quill.import('blots/block');
const Header = Quill.import('formats/header');
const Lists = Quill.import('formats/list');
const Code = Quill.import('formats/code');
declare const $: any;

export class InlineMarginParagraphs extends Block {
  static create() {
    const node = super.create();
    $(node).attr('style', 'margin: 0 !important;');
    return node;
  }
}

export class InlineMarginLists extends Lists {
  static create(value) {
    InlineMarginLists.tagName = value === 'ordered' ? 'OL' : 'UL';
    const node = super.create();
    $(node).attr('style', 'margin: 0 !important;');
    return node;
  }
}

export class InlineMarginHeaders extends Header {
  static formats(domNode: HTMLHeadingElement) {
    domNode.style.margin = '0';
    return this.tagName.indexOf(domNode.tagName) + 1;
  }
}
InlineMarginHeaders.blotName = 'header';
InlineMarginHeaders.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

